import * as angular from 'angular';
import 'angular-ui-router';
import SmartSalesView from './SmartSalesView.html';
import { SmartSalesController } from './SmartSalesController';
import { smartSalesPortalUrl } from 'app.constants';
import { SmartSalesFeatures } from './SmartSalesFeature';
export const smartSalesStateName = 'auth.application.detail.smartSales';
export const applicationDetailStateName = 'auth.application.detail.home';
export default angular
    .module('smartSales', ['ui.router', 'shared'])
    .config(['$sceDelegateProvider', ($sceDelegateProvider) => {
        $sceDelegateProvider.resourceUrlWhitelist([smartSalesPortalUrl]);
    }])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider.state(smartSalesStateName, {
            url: '/smart-sales',
            views: {
                'content@auth.application.detail': {
                    controller: SmartSalesController,
                    controllerAs: '$ctrl',
                    template: SmartSalesView,
                    resolve: {
                        authorization: fetchSmartSalesPermission,
                    },
                },
            },
        });
    }])
    .name;
const fetchSmartSalesPermission = ['$state', 'application', async function ($state, application) {
        const isSmartSalesEnabled = await SmartSalesFeatures.IsSmartSalesEnabled();
        if (!isSmartSalesEnabled) {
            $state.go(applicationDetailStateName, {
                shortName: application.shortName,
            });
        }
    }];
